module.exports = __webpack_public_path__ + "assets/images/e541741065a1c35e79717909172d1bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/instagram.png
// module id = 728
// module chunks = 0